<div class="card-header">
  <h2>Onboarding toolkit</h2>
</div>

<div class="card-body">
  <h4>Run Tech Check</h4>
  <p>
    Run a
    <a [href]="setupUrl" target="_blank">Tech Check</a>
    on all provider and student devices in the space where sessions will be
    delivered.
  </p>

  <h4>Learn the Kanga Basics</h4>
  <p>
    Find our short introductory course, Kanga Platform Foundations (&lt;1 hour),
    and a short assessments training video, if applicable, in the @if
    (isSiriusEnabled) {
    <a
      class="lms-link"
      [class.disabled]="isLmsLoading()"
      (click)="openLmsPortal()"
      >Telehealth Institute</a
    >. } @else { <a [href]="lms_url" target="_blank">Telehealth Institute</a>. }
  </p>

  <h4>Live Training</h4>
  <p>
    Need more? We are here to help! Contact your administrator to schedule a
    live training for your team, or email
    <a href="mailto:askaclinician&#64;presence.com"
      >askaclinician&#64;presence.com</a
    >.
  </p>
</div>
